import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GoogleLogin } from '@react-oauth/google';
import storage from '../../utils/storage';
import Logger from '../../utils/logger';
import { getDashboardRoute } from '../../hooks/useAuth';

/**
 * Composant pour le login Google
 * Utilise la librairie @react-oauth/google
 */
const GoogleLoginButton = () => {
  const navigate = useNavigate();

  const handleGoogleSuccess = useCallback(async (credentialResponse) => {
    try {
      Logger.log('🔐 Token Google reçu');

      const googleToken = credentialResponse.credential;

      // Envoyer le token au backend
      const response = await fetch(
        `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/accounts/google/login/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({ token: googleToken }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erreur lors de la connexion Google');
      }

      if (!data.success) {
        throw new Error(data.message || 'Erreur lors de la connexion Google');
      }

      // Stocker les tokens
      storage.setToken(data.access_token);
      if (data.user) {
        storage.setUser(data.user);
      }

      Logger.log('✅ Connexion Google réussie');
      toast.success(data.message || 'Connexion réussie !');

      // Rediriger vers le dashboard
      const dashboardRoute = getDashboardRoute(data.user?.role);
      console.log('➡️ Redirection vers le dashboard:', dashboardRoute);
      navigate(dashboardRoute, { replace: true });
    } catch (error) {
      Logger.error('❌ Erreur Google:', error);
      toast.error(error.message || 'Erreur lors de la connexion Google');
    }
  }, [navigate]);

  const handleGoogleError = useCallback(() => {
    Logger.error('❌ Erreur Google Login');
    toast.error('Erreur lors de la connexion avec Google');
  }, []);

  return (
    <div className="flex justify-center">
      <GoogleLogin
        onSuccess={handleGoogleSuccess}
        onError={handleGoogleError}
        text="signin_with"
        theme="outline"
        size="large"
      />
    </div>
  );
};

export default GoogleLoginButton;
